import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type {
    ItemPartContentProps,
    IItemFooterProps
} from "../../type";
import {
    withItemContext
} from "../../context";
import stylesheet from "../../stylesheet";

const ItemFooterBase: FC<ItemPartContentProps<IItemFooterProps>> = ({
    children,
    context,
    style,
    ...props
}) => {
    return <View
        {...props}
        style={[
            style,
            stylesheet.strip,
            context.isPressable ? stylesheet.passThrough : undefined
        ]}
    >
        {children}
    </View>;
};
export default withItemContext("footer", ItemFooterBase);
